<template>
  <div>
    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="$t('newLearningDepartment')">
      <header-button icon="mdi-close"
                     slot="left-button"
                     v-bind:label="$t('cancel')"
                     v-bind:to="{ name: 'learning-departments' }" />
      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="createLearningDepartment" />
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container>
      <v-row>
        <v-col cols="12"
               lg="6">
          <learningDepartment-details-card ref="learningDepartmentDetailsCard"
                                v-bind:learningDepartment="learningDepartment" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import LearningDepartmentDetailsCard from '@/components/learning/LearningDepartmentDetailsCard.vue'

  export default {
    components: {
      HeaderButton,
      LearningDepartmentDetailsCard,
      TopHeader
    },
    data: () => ({
      loading: false,
      learningDepartment: {},
      validationSnackbar: false
    }),
    methods: {
      async createLearningDepartment() {
        if (!this.$refs.learningDepartmentDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        await this.doCreateLearningDepartment({ learningDepartment: this.learningDepartment })

        this.$router.push({ name: 'learning-departments' })
      },
      ...mapActions({
        doCreateLearningDepartment: 'learning/createLearningDepartment'
      })
    },
    name: 'LearningDepartmentAdd'
  }
</script>

<i18n>
  {
    "de": {
      "cancel": "Abbrechen",
      "newLearningDepartment": "Neue Abteilung",
      "save": "Speichern",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "cancel": "Cancel",
      "newLearningDepartment": "New department",
      "save": "Save",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>